import * as React from 'react';
import { Card, Col, Row } from 'antd';

export const Kpi: React.FC<{ label: string; value: React.ReactNode }> = ({ label, value }) => (
    <div>
        <div style={{ fontSize: 11, color: 'var(--text-muted)', letterSpacing: 0.4 }}>{label}</div>
        <div style={{ fontSize: 22, fontWeight: 600, marginTop: 2 }}>{value}</div>
    </div>
);

const KpiStrip: React.FC<{ items: { label: string; value: React.ReactNode }[] }> = ({ items }) => (
    <Row gutter={16} style={{ marginBottom: 16 }}>
        {items.map((item) => (
            <Col span={Math.max(4, Math.floor(24 / Math.max(items.length, 1)))} key={item.label}>
                <Card size="small"><Kpi label={item.label} value={item.value} /></Card>
            </Col>
        ))}
    </Row>
);

export default KpiStrip;
